module.exports = __webpack_public_path__ + "static/media/sign-out-icon-white.0a0d36a0.svg";